











import Component from "vue-class-component";
import StandardSearch from "front-component/components/SelectSearch.vue";
import _ from "lodash";
import {Vue, Prop, Watch} from "vue-property-decorator";
import EventBus from "front-component/EventBus";
import { Getter } from "vuex-class";
import { Topic } from "@/modules/Topic";
import CsTreeSelect from "@/components/miscellaneous/CsTreeSelect.vue";

interface Node {
  id: string;
  uuid: string;
  label: string;
  value: string;
  children?: Node[];
}

@Component({ components: {CsTreeSelect, StandardSearch} })
export default class TopicSearch extends Vue {
    private filterValue: string | null = null;

    private defaultOption: object = {
        key: "",
        label: _.invoke(
            this.$options.filters,
            "trans",
            "allTopics"
        ),
    };

    @Prop({ default: "" }) public value!: string;
    @Prop() public filterName!: string;
    @Prop() public scopeOwnerUuid!: string;
    @Prop() public showScopeOwnerSelect!: boolean;

    private mounted() {
        this.filterValue =  this.value;
        this.$nextTick(() => {
            if (this.showScopeOwnerSelect && this.scopeOwnerUuid) {
                const existsInOptions = this.options.some((node) => {
                    if (node.value === this.filterValue) {
                        return true;
                    }
                    if (node.children && node.children.length) {
                        return node.children.some((child) => child.value === this.filterValue);
                    }
                    return false;
                });

                if (!existsInOptions) {
                    this.filterValue = null;
                    EventBus.$emit("update-filter", _.set({}, this.filterName, null));
                }
            }
        });
    }

    @Watch("value")
    private updateValue() {
        this.filterValue = this.value === "" ? null : this.value;
    }

    @Watch("filterValue") public onFilterChange(newValue: string): void {
        EventBus.$emit("update-filter", _.set({}, this.filterName, newValue));
    }

    @Watch("scopeOwnerUuid") private onScopeOwnerChange(): void {
        if (this.showScopeOwnerSelect && this.scopeOwnerUuid) {
        this.filterValue = null;
        EventBus.$emit("update-filter", _.set({}, this.filterName,  null));
        }
    }

    @Getter("getAllTopics") public allTopics!: Topic[];
    @Getter("getFilteredTopics") public filteredTopics!:
        (parentUuid: string | null, scopeOwnerUuid: string, withTopics: string[], allTopics: boolean) => Topic[];

    get options(): Node[] {
        const nodes: Node[] = [];

        const topics = _.sortBy(
            this.scopeOwnerUuid ?
                this.filteredTopics(null, this.scopeOwnerUuid, [], true) : this.allTopics,
            (line) => {
                return [line.parent !== null, line.title];
            }
        );

        _.forEach(topics, (topic) => {
            const node: Node = {
              id: topic.uuid,
              uuid: topic.uuid,
              label: topic.title,
              value: topic.uuid,
            };

            if (!topic.parent) {
                nodes.push(node);
                return;
            }

            const parent = _.find(nodes, { uuid: topic.parent.uuid });
            if (parent) {
                if (!parent.children) {
                    parent.children = [];
                }
                parent.children?.push(node);
            }
        });

        return nodes;
    }
}
